import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import pageLayout from 'HOC/pageLayout';
import PageTitle from 'components/PageTitle';
import Preloader from 'components/Preloader';
import PagesModule from 'modules/pages';


const EducationTrainingCertification = props => {
  const { isFetching, isFetched, getPageData, data } = props;
  const content = data?.content;
  const seo = data?.seo;

  useEffect(() => {
    getPageData();
  }, []);

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        <PageTitle
          align="center">{content?.title}</PageTitle>

        <div className="content-container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                {
                  isFetching &&
                  <Preloader />
                }
                {
                  content &&
                  <div
                    className="content-block"
                    dangerouslySetInnerHTML={{
                      __html: content.data
                    }}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default compose(
  pageLayout(),
  connect(state => ({
    data: state.pages['education-training-certification'],
    isFetching: state.pages.isFetching,
    isFetched: state.pages.isFetched,
  }), dispatch => ({
    getPageData: () => dispatch(PagesModule.fetch('education-training-certification'))
  })),
)(EducationTrainingCertification);
